import Actions from 'components/Actions';
import Button from 'components/Button';
import Card from 'components/Card';
import Flex from 'components/Flex';
import Modal from 'components/Modal';
import { StyledClose } from 'components/Modal/Basic';
import { IModal } from 'components/Modal/index';
import OverlaySpinner from 'components/OverlaySpinner';
import Small from 'components/PageTitle/Small';
import React, { FunctionComponent, useState } from 'react';
import styled from 'styled-components';

interface IConfirmModal extends IModal {
  confirm: () => void | Promise<unknown>;
  cancel?: () => void;
  question: string;
  titleSubmit?: string;
  titleCancel?: string;
  disableOnConfirm?: boolean;
}

const ConfirmModal: FunctionComponent<IConfirmModal> = ({
  isOpen,
  close,
  confirm,
  cancel,
  question,
  titleSubmit = 'Yes',
  titleCancel = 'No',
  disableOnConfirm = false,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleConfirm = async () => {
    if (!disableOnConfirm) {
      confirm();
      return;
    }

    if (isSubmitting) return;

    setIsSubmitting(true);
    try {
      await confirm();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} close={close}>
      <OverlaySpinner visible={isSubmitting} />
      <Card>
        <Header>
          <StyledClose onClick={close} />
        </Header>
        <ConfirmModalBody direction="column" alignItems="center">
          <Question className="mt16 mb32">{question}</Question>
          <Actions className="mt24" justifyContent="center">
            <Button type="submit" onClick={handleConfirm} className="mr8" disabled={isSubmitting}>
              {titleSubmit}
            </Button>
            <Button
              styleType="secondary"
              onClick={cancel || close}
              className="ml8"
              disabled={isSubmitting}
            >
              {titleCancel}
            </Button>
          </Actions>
        </ConfirmModalBody>
      </Card>
    </Modal>
  );
};

export default ConfirmModal;

export const ConfirmModalBody = styled(Flex)`
  padding: 0 63px 32px;
`;

const Header = styled(Flex)`
  padding: 25px 25px 15px;
`;

const Question = styled(Small)`
  text-align: center;
`;
